import { createFileRoute } from '@tanstack/react-router';

import { NotFoundMessage } from 'component/view/Redirects/NotFoundMessage';

export const Route = createFileRoute('/n/not-found')({
  component: NotFoundMessage,
});
